import type {FC} from 'react';

import type {AnswerModel} from '../../../../../../core/domain/Answer/Answer.model';
import type {CheckboxesAnswerModel} from '../../../../../../core/domain/Answer/CheckboxesAnswer/CheckboxesAnswer.model';
import type {MultipleChoiceAnswerModel} from '../../../../../../core/domain/Answer/MultipleChoiceAnswer/MultipleChoiceAnswer.model';
import type {TextAnswerModel} from '../../../../../../core/domain/Answer/TextAnswer/TextAnswer.model';
import type {ChoiceQuestionModel} from '../../../../../../core/domain/Question/ChoiceQuestion/ChoiceQuestion.model';
import type {TextQuestionModel} from '../../../../../../core/domain/Question/TextQuestion/TextQuestion.model';

import {type QuestionModel} from '../../../../../../core/domain/Question/Question.model';
import {CheckboxesQuestion} from './ChoiceQuestion/CheckboxesQuestion';
import {MultipleChoiceQuestion} from './ChoiceQuestion/MultipleChoiceQuestion';
import * as S from './styles';
import {TextQuestion} from './TextQuestion/TextQuestion';

type Props = {
  answer?: AnswerModel;
  hasError?: boolean;
  index: number;
  onAnswerChange?: (answer: AnswerModel) => void;
  question: QuestionModel;
};

export const CromQuestion: FC<Props> = ({
  answer,
  hasError,
  index,
  onAnswerChange,
  question,
}) => {
  const renderQuestionComponent = () => {
    switch (question.type) {
      case 'checkboxes':
        return (
          <CheckboxesQuestion
            answer={answer as CheckboxesAnswerModel}
            onAnswerChange={onAnswerChange}
            question={question as ChoiceQuestionModel}
          />
        );
      // TODO: Add long text question component
      case 'long_text':
      case 'short_text':
        return (
          <TextQuestion
            answer={answer as TextAnswerModel}
            onAnswerChange={onAnswerChange}
            question={question as TextQuestionModel}
          />
        );
      case 'multiple_choice':
        return (
          <MultipleChoiceQuestion
            answer={answer as MultipleChoiceAnswerModel}
            onAnswerChange={onAnswerChange}
            question={question as ChoiceQuestionModel}
          />
        );
      default:
        return null;
    }
  };

  return (
    <S.Container>
      <S.Title
        color={hasError ? 'error' : 'text.black'}
      >{`${index + 1}. ${question.title}${question.isRequired ? '*' : ''}`}</S.Title>
      {renderQuestionComponent()}
    </S.Container>
  );
};
